<template>
    <div>
        <UiCardListHeader
            :title="lang('reviews::reviews.widgets.latest_reviews.title')"
            :action-href="route('reviews.admin.index')"
            :action-label="lang('reviews::reviews.actions.manage')"
        />

        <UiCardEmpty v-if="reviews && reviews.length === 0">
            {{ lang('reviews::reviews.widgets.latest_reviews.no_reviews') }}
        </UiCardEmpty>
        <UiCardList
            v-else-if="reviews && reviews.length > 0"
            as="transition-group"
            name="slide-fade"
            enter-active-class="transition duration-300 ease-out transform"
            enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-20"
            enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
            leave-active-class="transition duration-100 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <review-preview v-for="review in reviews" :key="review.id" :review="review"></review-preview>
        </UiCardList>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { Ref } from 'vue';
import { usePage } from '@inertiajs/vue3';
import ReviewPreview from '@src/Reviews/Pages/Review/ReviewPreview.vue';

const { props } = usePage();

const components: Ref<any[]> = ref(props.components);

const component = [...components.value].find((component) => component.component === 'ReviewsBlock');

const reviews = ref(component ? component.reviews : []);

const loadReviews = () => {
    axios.get(route('reviews.admin.api.latest')).then(({ data }) => {
        reviews.value = data.reviews;
    });
};

window.Echo.channel('admin').listen('.notification', () => {
    loadReviews();
});

loadReviews();
</script>
